import { useContext, useState } from 'react';
import { uuidv4 } from '../util/uuidv4';
import {
  AlpNotificationType,
  NotificationFunctionContext,
} from '../components/notifications/notificationProvider';

type PostFunction = () => Promise<unknown>;

export interface Updater {
  doPost: (postFunction: PostFunction) => void;
  posting: boolean;
  error?: Error;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useUpdater = (
  onComplete?: (res?: any) => void,
  notify: boolean = true, // If errors should trigger a user notification
): Updater => {
  const [posting, setPosting] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();

  const { addNotification } = useContext(NotificationFunctionContext);

  async function doPost(postFunction: PostFunction) {
    setPosting(true);
    setError(undefined);

    postFunction()
      .then((res) => {
        if (onComplete) {
          onComplete(res);
        }
      })
      .catch((err) => {
        setError(err);

        if (notify) {
          addNotification({
            id: uuidv4(),
            type: AlpNotificationType.ERROR,
            message: err.body,
          });
        }
      })
      .finally(() => setPosting(false));
  }

  return { doPost, posting, error };
};
